export default class EliminarEquipoAsignadoUsecase {
  constructor(repository) {
    this.repository = repository
  }

  /**
   * Ejecuta la eliminación de equipos asignados
   * @param {Object} asignacionEquipo - La asignación de equipo a procesar
   * @param {Array} equipoEliminado - Array de IDs de equipos eliminados
   * @returns {Promise} Promesa que resuelve con el resultado de la actualización
   */
  async execute(asignacionEquipo, equipoEliminado) {
    const equipoAsignadoPayload = asignacionEquipo.equipoAsignado.map((equipo) => ({
      id: equipo.id,
      estatus: !equipoEliminado.includes(equipo.id),
      fk_idEquipo: equipo.fk_idEquipamiento,
    }))

    const payload = {
      ...asignacionEquipo,
      equipoAsignado: equipoAsignadoPayload,
    }

    return this.repository.updateEquipoAsignado(payload)
  }
}
